//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../Routing/Routing.PathStockBuilder.js";
import "../no/SelectNXObject.js";
import "../no/Section.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"ExternalFrameAnchorName",1,0],[1,"ExternalStockSettings",0,"Routing.PathStockBuilder",0],[0,"GrateOrientationReference",1,0],[0,"GrateOrientationSymbolDisplay",1,0],[1,"GrateOrientationSymbolRefSelection",0,"SelectNXObject",0],[0,"InternalFrameAnchorName",1,0],[1,"InternalStockSettings",0,"Routing.PathStockBuilder",0],[1,"PlateBoundariesSelection",0,"Section",0],[1,"SelectOuterBoundary",0,"Section",0],[0,"ThickenDirection",1,0],[0,"UseSameStock",1,0]],[[[],"SpecifyPlate",{},0,0],[[],"GetPlatePart",{R_:{platePart:"Routing.CharacteristicList"}},0,0],[["platePart"],"SetPlatePart",{},1,0],[[],"GetPlateAppliedCharx",{R_:{appliedCharx:"Routing.CharacteristicList"}},0,0],[["appliedCharx"],"SetPlateAppliedCharx",{},1,0]],[]];
SPLM.Routing.PlatformCreatorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.PlatformCreatorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.PlatformCreatorBuilder.ReferenceType = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical"});

export default SPLM;